export default {
  article: {
    title: 'USFans Spreadsheet: The Complete Beginner Guide',
    notFound: 'Article not found',
    updated: 'Last Updated: August 2026',
    author: 'USFansLink Editorial Team',
    quickLabel: 'Quick Answer',
    quickText: 'A USFans spreadsheet is an organized catalog of product links, categories, seller details and buying resources. This guide explains how to read it, what to check before ordering, and how to avoid common mistakes.',
    intro1: 'If you are new to the USFans ecosystem, the spreadsheet can look like a simple list of links at first. In reality, it is a structured buying resource that connects you to a wide range of products, from sneakers and hoodies to jerseys and accessories.',
    intro2: 'This guide walks you through what the spreadsheet is, what you will find inside it, how to use it step by step, and what to check before you place an order. It is written for beginners, so no prior experience is needed.',
    s1Title: 'What Is a USFans Spreadsheet?',
    s1p1: 'A USFans spreadsheet is a structured way to organize product links, categories and related buying resources in a single place. Instead of searching across many pages, you can browse organized categories and jump straight to the item you want on the main website.',
    s1p2: 'The spreadsheet is popular because it saves time. It groups products by category, keeps links together, and gives you a clear starting point for comparing items before you decide what to buy.',
    s2Title: 'What You Will Find Inside',
    s2p1: 'The spreadsheet is divided into clear product categories. The most common ones include:',
    s2Item1: 'Shoes — sneakers and casual footwear',
    s2Item2: 'Hoodies and sweaters for everyday wear',
    s2Item3: 'T-shirts in a range of styles and colors',
    s2Item4: 'Jackets and outerwear',
    s2Item5: 'Pants and shorts',
    s2Item6: 'Headwear such as caps and beanies',
    s2Item7: 'Matching sets and sportswear',
    s2Item8: 'Jerseys, accessories, bags, belts, perfumes and more',
    s3Title: 'How to Use the Spreadsheet Step by Step',
    s3p1: 'Using the spreadsheet is straightforward. Follow these steps to get the most out of it:',
    s3Step1: 'Choose the category that matches what you are looking for.',
    s3Step2: 'Click the category link to open the product list on the main website.',
    s3Step3: 'Browse the available items and compare their details.',
    s3Step4: 'Check the product description, available sizes and images carefully.',
    s3Step5: 'When you are ready, follow the normal checkout process on the main website.',
    s4Title: 'What to Check Before You Order',
    s4p1: 'A quick check before ordering can save you time and prevent mistakes. Use the table below as a simple checklist.',
    s4HeadFactor: 'Factor',
    s4HeadCheck: 'What to Check',
    s4HeadWhy: 'Why It Matters',
    s4r1Factor: 'Product',
    s4r1Check: 'Details, sizes and images',
    s4r1Why: 'Helps you avoid ordering the wrong item',
    s4r2Factor: 'Seller',
    s4r2Check: 'Seller information and reputation',
    s4r2Why: 'Lets you compare options before committing',
    s4r3Factor: 'QC',
    s4r3Check: 'Photos and inspection details',
    s4r3Why: 'Gives you a better idea of actual quality',
    s4r4Factor: 'Shipping',
    s4r4Check: 'Method, cost and delivery time',
    s4r4Why: 'Helps you plan and understand the total cost',
    s5Title: 'Shipping, QC and Safety',
    s5p1: 'Shipping costs and delivery times can vary depending on the item, the destination and the method you choose. Always review the shipping details before you finalize an order so there are no surprises later.',
    s5p2: 'Quality control, often shortened to QC, refers to the checks performed before an item is shipped. Looking for QC photos and inspection information can help you set realistic expectations about what you will receive.',
    s6Title: 'Is USFans Legit?',
    s6p1: 'USFansLink is an independent informational resource and does not sell products directly. As with any purchase, it is wise to verify important details independently, check the product information, and understand the shipping and refund policies before you buy. Being careful helps you shop with confidence.',
    faqTitle: 'Frequently Asked Questions',
    faq1q: 'Do I need an account to use the spreadsheet?',
    faq1a: 'The spreadsheet itself is a resource you can browse freely. You may need an account on the main website to complete a purchase.',
    faq2q: 'Are the prices shown in the spreadsheet?',
    faq2a: 'Prices and availability are managed by the main website. Check the product page there for current pricing.',
    faq3q: 'Can I compare products across categories?',
    faq3a: 'Yes. The spreadsheet is organized so you can move between categories and compare similar items before deciding.',
    faq4q: 'How often is the spreadsheet updated?',
    faq4a: 'USFansLink keeps the structure and links organized and updated regularly. Individual product availability is controlled by the main website.',
    ctaTitle: 'Ready to Explore the Spreadsheet?',
    ctaText: 'Browse the organized categories, compare products and jump straight to the main website when you find what you want.',
    ctaButton: 'Explore USFans Spreadsheet',
    backHome: 'Back to Home',
    related: 'Related Resources',
  },
};